import React from "react";
import "./TeamComponent.css";
import team1 from "../../images/our_team_1.png";
import team2 from "../../images/our_team_2.png";
import team3 from "../../images/our_team_3.png";
import team4 from "../../images/our_team_4.png";
import team5 from "../../images/our_team_5.png";
import team6 from "../../images/our_team_6.png";
import team7 from "../../images/our_team_7.png";
import team8 from "../../images/our_team_8.png";
import team9 from "../../images/our_team_9.png";
import team10 from "../../images/our_team_10.png";
import team11 from "../../images/our_team_11.png";
import team12 from "../../images/our_team_12.png";
import {
    FaTwitter,
    FaFacebookF,
    FaLinkedinIn,
    FaInstagram,
  } from "react-icons/fa";

const TeamComponent2 = () => {
  return (
    <section className="our_team_box_wrapper about_page_team_box">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="classes_workshop_title_outer m-auto text-center">
              <div className="smal_title smal_mid">
                <h5>Our Special Team</h5>
              </div>
              <div className="classes_workshop_title">
                <h2>
                  <span>Our instructors regularly</span>
                  conduct master classes.
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team1} alt="our_team_1" />
              </div>
              <div className="our_team_title">
                <h4>Camiele James</h4>
                <p>Founder &amp; CEO</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team2} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Filip Flekks</h4>
                <p>Manager</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team3} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Jenifer Kate</h4>
                <p>Sr. Yoga Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team4} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Sasha Briks</h4>
                <p>Sr. Yoga Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team5} alt="our_team_1" />
              </div>
              <div className="our_team_title">
                <h4>Uwe Walter</h4>
                <p>Yoga Instructor</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team6} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Elina Ekman</h4>
                <p>Meditation Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team7} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Lily Garner</h4>
                <p>Kundalini Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team8} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Razan Smith</h4>
                <p>Yoga Instructor</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team9} alt="our_team_1" />
              </div>
              <div className="our_team_title">
                <h4>Lucy Bond</h4>
                <p>Sr. Yoga Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team10} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Loren Spears</h4>
                <p>Sr. Yoga Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team11} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Aaron Nunez</h4>
                <p>Sr. Yoga Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="our_team_box">
              <div className="our_team_img">
                <img src={team12} alt="our_team" />
              </div>
              <div className="our_team_title">
                <h4>Lana White</h4>
                <p>Hatha Yoga Teacher</p>
              </div>
              <div className="hover_social_icon_team_box d-flex justify-content-center">
                <div className="hover_social_icon_box">
                <FaFacebookF />
                </div>
                <div className="hover_social_icon_box">
                <FaTwitter />
                </div>
                <div className="hover_social_icon_box">
                <FaInstagram />
                </div>
                <div className="hover_social_icon_box">
                <FaLinkedinIn />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamComponent2;
